import Button from '@/components/Button';
import Card from '@/components/Card';
import PodcastCard from '@/components/PodcastCard';
import Slider from '@/components/Slider';
import useIsMobile from '@/hooks/useIsMobile';
import { usePodcastStore } from '@/pages/podcast/store/usePodcastStore';
import isPodcastDone from '@/pages/podcast/utils/is-done';
import { PlayIcon } from '@heroicons/react/20/solid';
import { ArrowPathIcon } from '@heroicons/react/24/solid';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loading } from './loading';

export default function Podcast() {
  const { latestPodcastEpisodes, onInit, loading } = usePodcastStore();
  const navigate = useNavigate();
  const { isMobile } = useIsMobile();

  useEffect(() => {
    onInit();
  }, [onInit]);

  const renderContent = () => {
    return latestPodcastEpisodes?.map((podcast) => {
      const { isDone, progress } = isPodcastDone(podcast);

      const Component = isMobile ? Card : PodcastCard;
      return (
        <div key={podcast.id}>
          <Component
            key={podcast.id}
            title={podcast.attributes?.title || ''}
            description={podcast.attributes?.briefDescription || ''}
            url={`/podcast/${podcast.attributes?.slug}`}
            thumbnail={podcast.attributes?.cover}
            watchLabel={'Play'}
            progress={progress}
            button={
              <div className="flex items-center gap-4">
                <Button
                  theme={isDone ? 'outline' : 'solid'}
                  onClick={() => navigate(`/podcast/${podcast.attributes?.slug}`)}>
                  {isDone ? (
                    <ArrowPathIcon className="inline-block h-4 w-4" />
                  ) : (
                    <PlayIcon className="inline-block h-4 w-4" />
                  )}{' '}
                  <span className=" text-sh-xxs">{isDone ? 'Play again' : 'Play'}</span>
                </Button>
              </div>
            }
            author={''}
            image={{
              url: podcast.attributes?.cover?.data?.attributes?.url || '',
              alternativeText: '',
            }}
          />
        </div>
      );
    });
  };

  if (loading) {
    return <Loading />;
  }

  if (!isMobile) {
    return renderContent();
  }

  return (
    <>
      <Slider
        disableResponsiveDots={true}
        slideClassName="!max-h-none"
        sliders={renderContent()}
        options={{
          disabled: true,
          breakpoints: {
            '(max-width: 768px)': {
              disabled: false,
              loop: true,
              renderMode: 'performance',
              slides: { perView: 1, spacing: 16 },
            },
          },
        }}
      />
    </>
  );
}
